import { useEffect } from 'react';

// Services
import { getManagerLogout } from '../services/auth/authService';

// Components
import Page from '../components/templates/Page/Page';

/**
 * Logout component.
 * @returns {JSX.Element}
 */
function Logout() {
  const handleLogout = () => {
    getManagerLogout().then(() => {
      window.location.replace(import.meta.env.VITE_TOKEN_REDIRECT_URL);
    });
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return (
    <Page page={{ template: 'timeline', path: '/logout', format: null }} />
  );
}

export default Logout;
